var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-alert',{attrs:{"value":_vm.value,"type":_vm.type},scopedSlots:_vm._u([{key:"action",fn:function(){return [_vm._t("action")]},proxy:true}],null,true)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }